import { useEffect, useState } from "react";
import { NameServerResponse } from "../../../../../../api/resources/Networking/NamesServer";
import FetchAPI from "../../../../../../api/FetchAPI";
import { toastError } from "../../../../../../app_shared_functions";

const useFetchNameServers = () => {
  const [nameServers, setNameServers] = useState<NameServerResponse>({});

  useEffect(() => {
    FetchAPI.Networking.NamesServer.getList()
      .then((response) => {
        const data = response?.data;
        setNameServers(data);
      })
      .catch((error) => {
        toastError(error, "Error fetching default nameservers");
      });
  }, []);

  return nameServers;
};

export default useFetchNameServers;
